
    /**
    * Count number of full steps.
    */
    function countSteps(val, step, overflow){
        val = Math.floor(val / step);

        if (overflow) {
            return val % overflow;
        }

        return val;
    }

    module.exports = countSteps;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/countSteps.js
// module id = 268
// module chunks = 0 1 2